// extracted by mini-css-extract-plugin
export default {"title":"compendium-preview_title__HnUGr","subtitle":"compendium-preview_subtitle__YITun"};